import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { change, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import {PERFIL_ADMIN} from '../security/securityContext';
import Autorizacao from '../security/Autorizacao';

import limparViagens from '../actions/viagem/limpaViagens';
import ModalAlterarSenhaUsuario from './usuario/empresa/ModalAlterarSenhaUsuario';

import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined';
import DirectionsBusFilledOutlinedIcon from '@mui/icons-material/DirectionsBusFilledOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import InsertInvitationOutlinedIcon from '@material-ui/icons/InsertInvitationOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';


export class PaginaPrincipalGestao extends Component {
    onSubmit(values) {
        this.props.history.push(this.state.filtroSelecionado.url(values.numerow))
    }

    render() {
        return (
            <React.Fragment>
                <div>
                </div>
                <div className="area-home">
                    <div className="row sistemas justify-content-md-center mt-5">
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            {this.exibirLinkEmpresas()}
                            {this.exibirLinkCidades()}
                            {this.exibirLinkMapasVeiculos()}
                            {this.exibirLinkGerenciarUsuarios()}
                            {this.exibirLinkGerenciarInteressados()}
                            {this.exibirLinkGereciarEmpresas()}
                            {this.exibirLinkGerenciarCupons()}
                            {this.exibirLinkRelatorioGerencial()}
                            {this.exibirLinkRepassevenda()}
                            {this.exibirPassagensVendidas()}
                            {this.exibirLinkRemarcacao()}
                            {this.exibirAdesaoDePontos()}
                            {this.exibirLinkVexadoBI()}
                        </Autorizacao>
                    </div>
                </div>
                <div className="text-center">
                </div>
                <ModalAlterarSenhaUsuario />

            </React.Fragment>
        )
    }

    exibirLinkRemarcacao() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-remarcacao">
                        <div className="card card-inicial " style={{height: '90%'}}>
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><InsertInvitationOutlinedIcon className='css-icon' /></i>
                                <h5 className='nm-longo'>
                                    Remarcar/Cancelar passagem
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkRelatorioGerencial() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-relatorio-gerencial">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><PollOutlinedIcon className='css-icon' /></i>
                            <h5 className='nm-longo-resize'>
                                Relatório Gerencial
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }


    exibirLinkCidades() {
        return (

            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link id="menu-cidade" to="/painel-cidades">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><MapsHomeWorkOutlinedIcon className='css-icon' /></i>
                            <h5>
                                Cidades
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkEmpresas() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-empresas" id="menu-empresa">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><CorporateFareOutlinedIcon className='css-icon' /></i>
                            <h5>
                                Empresas
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkMapasVeiculos() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-mapas-veiculos">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><DirectionsBusFilledOutlinedIcon className='css-icon' /></i>
                            <h5 className='nm-longo-resize'>
                                Mapas de Veículos
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkGerenciarCupons() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-cupons">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><ConfirmationNumberOutlinedIcon className='css-icon' /></i>
                            <h5>
                                Cupons
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkGerenciarUsuarios() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/menu-usuario">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                            <h5>
                                Usuários
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkGerenciarInteressados() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/interessados-promocao">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><SupervisorAccountOutlinedIcon className='css-icon' /></i>
                            <h5 className='nm-longo'>
                                Interessados e Clientes
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkGereciarEmpresas() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/gestao-empresa">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons"><QueryStatsOutlinedIcon className='css-icon' /></i>
                            <h5>
                                Gerencial
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirLinkRepassevenda() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-repasse-venda" id="menu-empresa">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i className="material-icons custom-icons">&#xeb3f;</i>
                            <h5>
                                Repasse Venda
                            </h5>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }

    exibirPassagensVendidas() {
        return (
            <div className="col-6 col-sm-6 col-md-3 mt-3">
                <Link to="/painel-vendas" id="menu-empresa">
                    <div className="card card-inicial ">
                        <div className="card card-inicial-interno ">
                            <i id='iconPassagensVendidas' className="fa fa-line-chart"></i>
                            <h5>
                                Passagens Vendidas
                            </h5>
                        </div>
                    </div>
                </Link >
            </div >
        )
    }

    exibirAdesaoDePontos() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to='/menu-adesao-pontos' id="menu-empresa">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons">
                                    <CorporateFareOutlinedIcon className='css-icon' />
                                </i>
                                <h5>
                                    Adesão de pontos
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }

    exibirLinkVexadoBI() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-6 col-sm-6 col-md-3 mt-3">
                    <Link to="/painel-vexado-bi">
                        <div className="card card-inicial ">
                            <div className="card card-inicial-interno ">
                                <i className="material-icons custom-icons"><AnalyticsOutlinedIcon className='css-icon' /></i>
                                <h5>
                                    VexBI
                                </h5>
                            </div>
                        </div>
                    </Link>
                </div>
            </Autorizacao>
        )
    }
}


export function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue(field, value) {
            dispatch(change('PaginaInicialForm', field, value))
        },
        limparViagens
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
        form: 'PaginaInicialForm',
    })(withRouter(PaginaPrincipalGestao))
)
